module.exports = __webpack_public_path__ + "static/media/logo.0d193f45.png";